import { PageId } from "../types/pageId";

export const upperFunnelPages = [PageId.Category, PageId.PLP, PageId.SearchPages, PageId.SearchDesignTiles, PageId.RecommendationLane, PageId.Favorites, PageId.LaunchMyBusiness, PageId.RecommendationLane, PageId.RecommendationLaneWithQuantity, PageId.FavoritesTemplateSection];
